import { ClinicContact } from "../../../api/clinic.types";
import { ClinicContactsAction } from "./clinic.contacts.types";

export const clinicContactsRequestAction = (): ClinicContactsAction => ({ type: 'CLINIC_CONTACTS_REQUEST' })
export const clinicContactsSuccessAction = (contacts: ClinicContact[]): ClinicContactsAction => ({ type: 'CLINIC_CONTACTS_SUCCESS', params: contacts })
export const clinicContactsFailureAction = (error?: any): ClinicContactsAction => ({ type: 'CLINIC_CONTACTS_FAILURE', params: error })